import React from 'react';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';

/** digital image section id and testId */
export var SECTION_ID = 'digital-image-what-im-citing';
export var SECTION_TEST_ID = "".concat(SECTION_ID, "-test-id");

/** section input test ids */
export var IMAGE_TITLE_INPUT_TEST_ID = 'image-title-test-id';
export var IMAGE_DESCRIPTION_INPUT_TEST_ID = 'image-description-test-id';
export var DigitalImageCitingSection = function DigitalImageCitingSection() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    name: "image.title",
    labelText: "Title",
    helperText: "Official image title, if any.",
    "data-test": IMAGE_TITLE_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    name: "image.desc",
    labelText: "Description",
    helperText: "If no official title, please describe.",
    "data-test": IMAGE_DESCRIPTION_INPUT_TEST_ID
  }));
};